import { RowData } from '../../../baseComponents/TwinTable/types'
import TwinToolTip from '../../../baseComponents/TwinToolTip'
import { SellTagsPayload } from '../../../utils/reducers/sells/sellTags'

interface RenderSellTagsProps {
    allRowData: RowData
    sellTags: SellTagsPayload
}

export const RenderSellTags: React.FC<RenderSellTagsProps> = ({ allRowData, sellTags }) => {
    if (!allRowData?.OrderTagRels?.length) {
        return <div>--</div>
    }
    const renderThis: JSX.Element[] = []
    const shortVersion = allRowData.OrderTagRels?.length > Math.floor(allRowData['_myColumnWidth'] / 80)
    for (const key in allRowData.OrderTagRels) {
        const tagId = allRowData.OrderTagRels[key].OrderTagId
        const tag = sellTags?.allTags?.[tagId]
        const id = 'SellDeliveryNote_' + allRowData?.id + '_' + tagId
        if (tag) {
            renderThis.push(
                <div className='max-w-full' key={key}>
                    <TwinToolTip id={id} place='top' content={tag?.name} />
                    <div className='flex items-center ' data-tooltip-id={id}>
                        <div className={'rounded-full h-10 w-10 border border-gray-D6 min-h-10 min-w-10 '} style={{ backgroundColor: tag?.color }} />
                        {!shortVersion ? <span className='ml-5 twin_elipsis'>{tag?.name}</span> : null}
                    </div>
                </div>
            )
        }
    }
    return (
        <div className={'flex items-center flex-wrap max-w-full ' + (shortVersion ? 'gap-x-5' : 'gap-x-10')}>
            {renderThis}
        </div>
    )
}